<template>
  <v-container>
    <v-tour name="myTour" :steps="steps"></v-tour>
  </v-container>
</template>

<script>
export default {
  name: "tours",
  data() {
    return {};
  },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    let path = this.$router.getMatchedComponents()[0].name.toLowerCase();
    let tourCookies = this.$cookies.get("tour");

    if (tourCookies == null) {
      let cookieString = {};
      cookieString[path] = true;
      this.$cookies.set("tour", JSON.stringify(cookieString), "1y");
      this.$tours["myTour"].start();
    } else {
      try {
        let value = tourCookies[path];
        console.log(value);
        if (value === undefined || value === null) {
          this.$tours["myTour"].start();
          tourCookies[path] = true;
          this.$cookies.set("tour", JSON.stringify(tourCookies), "1y");
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

